export const BALANCE_MODALS = {
  SETTLEMENT: 'settlement',
  WITHDRAW: 'withdraw',
} as const;

export const INSTANT_SETTLEMENT_BALANCE_TYPES = {
  AVAILABLE: 'available',
  PENDING: 'pending',
} as const;

export const BALANCE_FORM_FIELDS = {
  AMOUNT: 'amount',
} as const;

export const BALANCE_FIELDS = {
  [BALANCE_FORM_FIELDS.AMOUNT]: {
    value: '',
    errorMsg: '',
    isValid: false,
    validations: [],
  },
} as const;

export const DEBOUNCED_TIME = 1000;

export const INSTANT_SETTLEMENT_VERSION = 2;

export const HAVE_ONE_SETTLE_WAY = 1;
